import { DesktopInput } from './DesktopInput'
import { TouchInput } from './TouchInput'
import type { InputState } from './InputTypes'

function isMobileInputDevice(): boolean {
  const hasFinePointer = window.matchMedia?.('(pointer: fine)').matches ?? false
  if (hasFinePointer) return false

  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  if (window.Telegram?.WebApp && hasTouch) return true

  const ua = navigator.userAgent || ''
  const isMobileUa = /Android|iPhone|iPad|iPod|Mobile|Windows Phone/i.test(ua)
  if (hasTouch && isMobileUa) return true

  const coarse = window.matchMedia?.('(pointer: coarse)').matches ?? false
  return hasTouch && coarse
}

export class SteeringInputV4 {
  private readonly input: DesktopInput | TouchInput
  private readonly touchMode: boolean

  constructor(canvas: HTMLCanvasElement) {
    this.touchMode = isMobileInputDevice()
    this.input = this.touchMode
      ? new TouchInput(canvas)
      : new DesktopInput(canvas)
  }

  update(): InputState {
    return this.input.getState()
  }

  isTouchMode(): boolean {
    return this.touchMode
  }

  getTouchInput(): TouchInput | null {
    return this.touchMode ? (this.input as TouchInput) : null
  }

  dispose(): void {
    this.input.dispose()
  }
}
